import { render, staticRenderFns } from "./ServiceComputation.vue?vue&type=template&id=6da8c3b6&scoped=true&"
import script from "./ServiceComputation.vue?vue&type=script&lang=js&"
export * from "./ServiceComputation.vue?vue&type=script&lang=js&"
import style0 from "./ServiceComputation.vue?vue&type=style&index=0&id=6da8c3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da8c3b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da8c3b6')) {
      api.createRecord('6da8c3b6', component.options)
    } else {
      api.reload('6da8c3b6', component.options)
    }
    module.hot.accept("./ServiceComputation.vue?vue&type=template&id=6da8c3b6&scoped=true&", function () {
      api.rerender('6da8c3b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ServiceComputation.vue"
export default component.exports